export default {
  coy: function coy() {
    return null;
  },
  dark: function dark() {
    return null;
  },
  funky: function funky() {
    return null;
  },
  okaidia: function okaidia() {
    return null;
  },
  prism: function prism() {
    return null;
  },
  solarizedlight: function solarizedlight() {
    return null;
  },
  tomorrow: function tomorrow() {
    return null;
  },
  twilight: function twilight() {
    return null;
  }
};